import React from 'react'
import ScaleLoader from "react-spinners/ScaleLoader";

export default function Loading() {
    return (
        <div 
            id="page-top" 
            style={{display: 'flex', justifyContent: 'center', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                <ScaleLoader color="#f76e2b" loading={true} size={150} />
                <h4>Loading...</h4>
            </div>
        </div>
    )
}
